import React from "react";
import CPBoardView from "../components/CPBoardView";
import { Container } from "@amzn/awsui-components-react";

const AIDecisionTree = ({selectedCPView, viewAccess, addOrEditAccess, resetHref}) => (
  <Container>
    <CPBoardView
      pageType="AI Decision Tree"
      tabType="BOARD"
      owner={selectedCPView}
      viewAccess={viewAccess}
      addOrEditAccess={addOrEditAccess}
    />
  </Container>
);

export default AIDecisionTree;
